<template>
<transition name="zoom">
    <v-touch
      @swipeleft="swipeLeft"
      @swiperight="swipeRight"
      :swipe-options="{direction: 'horizontal'}"
      class="v-touch"
    >
  <div class="order_detail">

    <Header :color="'white'" :fontColor="'black'">
      <div slot="center" class="header_btn">
        <div @click="changeOrderType(0)" :class="{type_active: isTypeActive===0}">我的订单</div>
        <div @click="changeOrderType(1)" :class="{type_active: isTypeActive===1}">团队订单</div>
      </div>
    </Header>
    <div class="nav">
      <div v-for="(item,index) in title" :key="index" @click="changeStatus(index)" class="nav-item">
        <div :class="{active:isActive == index }">
          {{item.title}}
        </div>
      </div>
    </div>
    <div class="tips">
      温馨小提醒：订单付款成功后1~10分钟才会同步显示哦~
    </div>
    <!-- @swipedown="swipeDown" -->
    <van-pull-refresh v-model="down" @refresh="swipeDown">
      <transition
        :name="animation"
      >
        
        <div class="order_content" v-if="load">
          <!-- <van-loading v-show="down" /> -->
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getOrderData()"
          >
            <div class="card" v-for="(item,index) in orderData" :key="index">
              <div class="top">
                <span class="top_left">
                  <span class="source" v-if="item.orderSource=='TAOBAO'"><img src="@/assets/个人中心/taobao.png" /></span>
                  <span class="source" v-else-if="item.orderSource=='JD'"><img src="@/assets/个人中心/JD.png" /></span>
                  <span class="source"  v-else-if="item.orderSource=='PINDD'"></span>
                  {{item.payTime | parseTime2}}
                </span>
                <span v-if="item.status === 1" style="color:rgb(255,30,20)">待返利</span>
                <span v-else-if="item.status === 2" style="color:grey">已失效</span>
                <span v-else-if="item.status === 3" style="color:color:rgb(0,205,20)">已结算</span>
                <span v-else-if="item.status === 4" style="color:color:grey">已到账</span>
              </div>
              <div class="main">
                <img :src="item.goodsImg" alt="">
                <div class="main_content">
                  <span class="title">{{item.goodsName}}</span>
                  <div class="bottom">
                    <span class="price">￥{{item.actualAmount}}</span> 
                    <div class="back-amount" :class="{disable:item.status === 2}"><div>赚</div>
                    <span v-if="isTypeActive===0">{{item.backAmount}}元</span>
                    <span v-else>{{item.activeUserBackAmount}}元</span>
                    
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="bottom">
                <span>订单编号：{{item.orderNo}}</span>
                <span v-clipboard:copy="item.orderNo" v-clipboard:success="onCopy"  v-clipboard:error="onCopyError">复制</span>
              </div>
            </div>
          </van-list>


        </div>

        <!-- <div  class="order_content" v-else>
          <div class="noOrder"><img src="@/assets/个人中心/order.png" /><div>没有订单</div></div>
        </div> -->
          </transition>
        
        </van-pull-refresh>
        
  </div>
  </v-touch>
</transition>
</template>

<script>
import Header from "@/components/Header";
import { orderPagerList } from "@/api/ownCenter";
import { Notify } from 'vant';
export default {
  components:{
    Header
  },
  data(){
    return{
      title:[
        {title:'全部订单',path:''},
        {title:'待返利',path:''},
        {title:'已失效',path:''},
        {title:'已结算',path:''},
        {title:'已到账',path:''},
      ],
      isActive:0,
      orderData:[
      ],
      isTypeActive:0,
      copyContent:'',
      loading: false,
      finished: false,
      animation: 'left',
      load:true,
      down:false,
      lastId:''
    }
  },
  computed:{

  },
  created () {
    this.down = true
    // this.getOrderData()   
    
  },
  methods:{
    getOrderData(){ //获取订单Data
      const data = {
        status: this.isActive,
        userId: this.$store.state.userId, 
        fansOrderStatus: this.isTypeActive,
        lastId:  this.lastId
      }

      orderPagerList(data).then(res=>{
        this.loading = false
        this.orderData = this.orderData.concat(res.data)
        this.load = true
        this.down = false
        if(res.data.length === 0){
          this.finished = true
        }else{
          this.lastId = this.orderData[this.orderData.length-1].id
          this.finished = false
        }

        
      })  
    },
    changeStatus(index){
      if (this.isActive > index) {
        this.animation = 'right'
      } else {
        this.animation = 'left'
      } 
      this.isActive = index

      this.load = false
      this.orderData = []
      this.lastId = ''
      this.getOrderData()   
      this.toTop()   
    },
    changeOrderType(type){
      this.isTypeActive = type
      this.orderData = []
      this.lastId = ''
      this.getOrderData()
      this.toTop()
    },
    onCopy(){
      Notify({ type: 'success', message: '复制成功' });
    },
    onCopyError(){
      Notify({ type: 'warning', message: '复制失败' });
    },
    toTop(){
      // const a = document.createElement('a'); 
      // a.setAttribute('href', '#top');
      // a.click();
      document.documentElement.scrollTop = 0
    },
    // 左滑
    swipeLeft() {
      if (this.isActive < 4) {
        this.animation = 'left'
        this.load = false
        this.isActive++
        
         
      }else{
        if(this.isTypeActive === 1){
          return
        }
        this.isTypeActive++
        this.isActive = 0
      }
      this.lastId = ''
      this.orderData = []
      this.getOrderData() 
      this.toTop()
    },
    // 右滑
    swipeRight() {
      if (this.isActive > 0) {
        this.animation = 'right'
        this.load = false
        this.isActive--
        
          
      }else{
        if(this.isTypeActive === 0){
          return
        }
        this.isTypeActive--
        this.isActive = 4
      }
      this.orderData = []
      this.lastId = ''
      this.toTop()
      this.getOrderData()
    },
    swipeDown() {
      this.down = true
      setTimeout(() => {
        this.orderData = []
        this.lastId = ''
        this.getOrderData()
      }, 200);
    }
  }
}
</script>
<style>
.left-enter-active,.right-enter-active,.left-leave-active,.right-leave-active {
  opacity: 0.8;
  transition: all .6s ease;
}

.left-enter
 {
  transform: translateX(150%);
  opacity: 0;
}

.right-enter {
  transform: translateX(-150%);
  opacity: 0;
}
</style>
<style lang="less" scoped>
// /deep/ .van-list__finished-text{
//   height: 100vh;

// }
.order_detail{
  height: 100vh;
  .tips{
    width: 100vw;
    height: 2.6rem;
    background-color: #FDF5E6;
    text-align: center;
    line-height: 2.6rem;
    color: #B8860B;
    position: fixed;
    top: 8.8rem;
    z-index: 9910;
  }
  .header_btn{
    display: flex;
    font-size: 1.5rem;
    align-items: center;
    :nth-child(1){
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;  
      border-right: 0;    
    }
    :nth-child(2){
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;      
    }

    div{
      padding: 5px;
      text-align: center;
      width: 40rem;
      white-space: nowrap;
      border: 1px solid transparent;
      border-radius: 4px;
      color: rgb(150, 150, 150);
      background-color: rgba(240, 240, 240,.7);
    }
    .type_active{
      background-color: #F63A25;
      color: white;
    }
  }
  .nav{
    position: fixed;
    top: 4.8rem;
    display: flex;
    justify-content: space-around;
    z-index: 9910;
    // align-items: center;
    width: 100vw;
    height: 4rem;
    background-color: #fff;
    text-align: center;
    font-size: 1.4rem;
    box-sizing: border-box;
    color: grey;
    .nav-item{
      width: 25vw;
      box-sizing: border-box;
      height: 4rem;
      padding: 1.4rem 0 0 0;
      position: relative;
    }
    .active{
      padding-bottom:1rem ;
      font-size: 1.6rem;
      // border-bottom: solid black 0.15rem ;
      &::after{
        content: '';
        width: 2rem;
        height: 2px;
        background-color: #F63A25;
        position: absolute;
        bottom: 0rem;
        left: 2.6rem;
        
      }
      color: black;
 
    }

  }
    .order_content{
      text-align: center;
      font-size: 1.6rem;
      color: grey;
      margin-top: 8rem;
      .card{
        width: 95vw;
        margin-left: 2.5vw;
        border-radius: 10px;
        background-color: #fff;
        height: 20rem;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 2vw;
        .top{
          height: 2rem;
          border-bottom: 1px solid rgba(130, 130, 130, 0.1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          vertical-align: bottom;
          padding-bottom: 10px;
          font-size: 1.3rem;
          color: black;
          .source{
            
            img{
              vertical-align:text-bottom;
              width: 1.6rem;
              height: 1.6rem;
            }

          }
        }
        .main{
          // height: 12rem;
          display: flex;
          justify-content: space-between;
          img{
            width: 8.2rem;
            height: 8.2rem;
            border-radius: 6px;
          }
          .main_content{
            display: flex;
            flex-direction: column;
            text-align: left;
            justify-content: space-between;
            // margin-left: 10px;
            .title{
              width: 24rem;
              color: black;
              overflow: hidden;
              
              text-overflow: ellipsis;
              white-space: nowrap;
              
            }
            .bottom{
              display: flex;
              justify-content: space-between;
              border: 0;
              .disable{
                div{
                  background-color: rgba(120,120,120,1) !important;
                  &::after{
                    content: '';
                    position: absolute;
                    width:0;
                    height:0;
                    border-right:.5rem solid transparent;
                    border-left:0.5rem solid transparent;
                    border-top:1.7rem solid rgba(120,120,120,1) !important;
                    z-index: 10;
                    // border: 0  !important;
                  }
                }
                span{
                  background-color: rgba(200,200,200,0.7) !important;
                  color: rgba(100,100,100,0.7) !important;
                  position: relative;
                  &::after{
                    content: '';
                    width: 80%;
                    height: 1px;
                    background-color: rgba(100,100,100,0.7);
                    position: absolute;
                    left: .6rem;
                    top: 0.8rem;
                  }
                }
              }
              .back-amount{
                width: 7.5rem;
                color: white;
                height: 1.7rem;
                line-height: 1.8rem;
                display: flex;
                justify-content: space-around;
                font-size: 1rem;
                
                // align-items: center;
                // padding: .5rem;
                // box-sizing: border-box;
                div{

                  border-top-left-radius: 2px;
                  border-bottom-left-radius: 2px;
                  background-color: rgb(40, 40, 40);
                  color: #F63A25;
                  width: 2rem;
                  color: white;
                                    font-size: 1rem;
                  text-align: center;
                  &::after{
                    content: '';
                    position: absolute;
                    width:0;
                    height:0;
                    border-right:.5rem solid transparent;
                    border-left:0.5rem solid transparent;
                    border-top:1.7rem solid rgb(40, 40, 40);
                  }
                }
                span{
                  border-top-right-radius: 2px;
                  border-bottom-right-radius: 2px;
                  width: 5.5rem;
                  background-color:  #F63A25;
                  text-align: center;
                  color: white;
                  font-size: 1.1rem;

                  font-weight: 500;
                }
              }
            }

            .price{
              color: rgba(235, 10, 10, 1);
              font-weight: 600;
            }
          }
        }
        .bottom{
          height: 2rem;
          border-top: 1px solid rgba(130, 130, 130, 0.1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 10px;
          font-size: 1.3rem;
        }
      }
    }
}
.noOrder{

  img{
    opacity: 0.4;
    margin: 20rem 0  1rem 0;
    width: 4rem;
    height: 4rem;
  }
}
</style>